import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ecommerce-dev',
  templateUrl: './ecommerce-dev.component.html',
  styleUrls: ['./ecommerce-dev.component.css']
})
export class EcommerceDevComponent implements OnInit {

  constructor(private commonScriptComponent: CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/ecommerce-dev/ecommerce-dev.component.ts